import { ThemeCss } from "gatsby-interface"

export const viewBuildQueueTabCss: ThemeCss = _theme => ({
  alignSelf: `center`,
  margin: 0,
  marginLeft: `auto`,
})
